import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
  OnInit, OnDestroy, ViewChild
} from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { SearchModel } from 'shared/search/search.model';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';

import { BrandService } from 'shared/brand/brand.service';
import { CurrentProductsSearchService } from './current-products-search.service';
import { ProductCopyType } from 'shared/modal/create-product-copy-modal/product-copy-type';


@Component({
  moduleId: module.id,
  selector: 'current-products-search',
  templateUrl: 'current-products-search.component.html',
  styleUrls: ['current-products-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentProductsSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Input() declare searchResultsColumns: Array<any>;

  @Input() selectable: boolean = false;

  @Input() hasListIcon: boolean = false;

  @Input() ghostValue: string = 'products';

  @Input() type: ProductCopyType;

  @Output() openProductLists: EventEmitter<any> = new EventEmitter();

  @Output() productSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild(HiddenScrollComponent, {static: false})
  hiddenScroll: HiddenScrollComponent | void;

  declare searchModel: SearchModel;
  declare _searchModel: BehaviorSubject<SearchModel>;
  declare searchModelObservable: Observable<SearchModel>;
  listIsShown: boolean = false;

  constructor(
    public searchService: CurrentProductsSearchService,
    public brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  startSearch() {
    if (!this.searchModelSub) {
      this.initSubscriptions();
    } else {
      this.runSearch(this.searchModel);
    }
    _.defer(() => this.hiddenScroll && this.hiddenScroll.defineContentWidth());
  }

  resetData() {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
  }

  runSearch(searchModel: SearchModel) {
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .subscribe((res: any) => {
      this.ref.markForCheck();
    });
  }

  ngOnInit() {
    this.searchModel = new SearchModel();
  }

  ngOnDestroy() {
    this.destroySubscriptions();
  }

  onCheckboxChanged(item: any) {
    if (this.type === ProductCopyType.CopyData) {
      super.onCheckboxChanged(item);
      return;
    }

    // only one product for copy creating
    if (item.selected) {
      _.defer(() => {
        this.searchService.pullSelectAllChecked(this.searchModel.currentPage, _.get(this.searchModel.statusModel, 'id'));
        this.searchService.searchResults.map((i: any) => {
          if (i.partNumber !== item.partNumber) {
            i.selected = false;
            this.searchService.pullSelectedItem(i);
          } else {
            i.selected = true;
            this.searchService.pushSelectedItem(i);
          }
        });
        this.ref.markForCheck();
      });
    } else {
      this.searchService.pullSelectedItem(item);
    }
  }

  onListIconClick() {
    this.openProductLists.emit();
  }

  onRowClick(row: any) {
    this.productSelect.emit(row);
  }
}
